import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "semantic-ui-react";

import { Can } from "components";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { AddUpdateTyreDiscountModal, TyreDiscountsTable } from "modules/TyreDiscountsDashboard/components";
import "modules/TyreDiscountsDashboard/TyreDiscountsDashboard.scss";

export const TyreDiscountsDashboard = () => {
  const { t } = useTranslation();

  const [showAddUpdatedTyreDiscountModal, setShowAddUpdateTyreDiscountModal] = useState(false);

  return (
    <div className="TyreDiscountsDashboard">
      <Can I={ACL_ACTIVITIES.Create} the={ACL_RESOURCES.TyreDiscounts}>
        <div className="toolbar">
          <Button
            icon="plus"
            className="add-button"
            labelPosition="left"
            content={t("v8_add_discount", "Add Discount")}
            onClick={() => setShowAddUpdateTyreDiscountModal(true)}
          />
        </div>
      </Can>
      <TyreDiscountsTable />
      <AddUpdateTyreDiscountModal isOpen={showAddUpdatedTyreDiscountModal} onClose={() => setShowAddUpdateTyreDiscountModal(false)} tyreDiscount={null} />
    </div>
  );
};
